import React, { useState, useEffect } from "react";
import { connect } from "react-redux"
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import CheckBox, { CheckBoxLabelSize } from "../../UI/Button/CheckboxButton";
import ErrorPanel from "../../UI/ErrorPanel/ErrorPanel";
import * as SearchUtils from "../../Utils/SearchUtils";
import * as SearchConstant from "../../Constants/SearchConstant";
import * as CustomDataUtils from "../../../middleware/Utils/CustomDataUtils";
import * as ErrorUtils from "../../Utils/ErrorUtils";
import styles from "./SearchPreferences.module.scss";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import * as UserActions from "../../../middleware/Store/Actions/UserActions";

import LogService from "../../../middleware/CommonSdk/LogService";
import PropTypes from "prop-types";

const LOG_TAG = "SETTINGS-SEARCH-PREFERENCES";

const SearchPreferences = (props) => {
    const [searchFilterList, setSearchFilterList] = useState([]);
    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const intl = useIntl();

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect customUserData");
        const searchIndexPreferences = CustomDataUtils.getSearchIndexPreferences(props.customUserData);
        if (searchIndexPreferences.length > 0) {
            setSearchFilterList(searchIndexPreferences);
        }
    }, [props.customUserData]);

    const handleSearchFilterItemToggle = (itemId) => {
        LogService.trace(LOG_TAG, "handleSearchFilterItemToggle:", itemId);
        const index = searchFilterList.indexOf(itemId);
        if (index < 0) {
            setSearchFilterList([...searchFilterList, itemId]);
        } else {
            setSearchFilterList(searchFilterList.filter((item) => (item !== itemId)));
        }
    }

    const handleSetSearchPreferences = () => {
        LogService.trace(LOG_TAG, "handleSetSearchPreferences:");
        setProgress(true);
        props.updateSearchPreferences(searchFilterList)
            .then(() => {
                LogService.trace(LOG_TAG, "handleSetSearchPreferences success");
                setProgress(false);
            })
            .catch((errorPayload) => {
                LogService.trace(LOG_TAG, "handleSetSearchPreferences error");
                setProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
            });
    }

    LogService.info(LOG_TAG, "render");

    const sdkFilterItems = SearchUtils.getAllSdkFilterList()
        .map((filterItem) => {
            const displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const apiFilterItems = SearchUtils.getAllApiFilterList()
        .map((filterItem) => {
            const displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const otherFilterItems = SearchUtils.getAllOtherFilterList()
        .map((filterItem) => {
            let displayName = SearchUtils.getDisplayNameFromFilterItem(filterItem);
            displayName = intl.messages[filterItem] ? intl.messages[filterItem] : displayName;
            const isSearchFilterItemSelected = searchFilterList.indexOf(filterItem) >= 0;
            return (
                <CheckBox
                    key={filterItem}
                    checked={isSearchFilterItemSelected}
                    label={displayName}
                    labelSize={CheckBoxLabelSize.Small}
                    onClick={() => handleSearchFilterItemToggle(filterItem)}
                />
            );
        });

    const searchFilterItemlist = [];
    if (sdkFilterItems.length > 0) {
        searchFilterItemlist.push(
            <li key="0" className={"list " + styles.itemSelection}>
                <div id={SearchConstant.SearchFilterSdkPrefix} className="list-title pb-2">{intl.messages.searchFilterSdk}</div>
                {sdkFilterItems}
            </li>
        );
    }
    if (apiFilterItems.length > 0) {
        searchFilterItemlist.push(
            <li key="1" className={"list " + styles.itemSelection}>
                <div id={SearchConstant.SearchFilterApiPrefix} className="list-title pb-2">{intl.messages.searchFilterApi}</div>
                {apiFilterItems}
            </li>
        )
    };
    if (otherFilterItems.length > 0) {
        searchFilterItemlist.push(
            <li key="2" className={"list " + styles.itemSelection}>
                <div id={SearchConstant.SearchFilterOtherPrefix} className="list-title pb-2">{intl.messages.searchFilterOther}</div>
                {otherFilterItems}
            </li>
        )
    };

    return (
        <Card title={intl.messages.settingsSearchPreferencesTitle}>
            <div className="form-group">
                {searchFilterItemlist}
            </div>

            <div className="panel bg-fog mb-3">
                {intl.messages.settingsSearchPreferencesMessage}
            </div>

            <Button
                label={intl.messages.apply}
                icon={faCheck}
                className="btn-submit"
                spinner={progress}
                disabled={progress}
                onClick={handleSetSearchPreferences}
            />

            {(errorMessage) &&
                <div className="col-10 float-right">
                    <ErrorPanel >{errorMessage}</ErrorPanel>
                </div>
            }
        </Card>
    );
}

SearchPreferences.propTypes = {
    customUserData: PropTypes.object
}

const mapStateToProps = state => {
    return {
        customUserData: state.user.customUserData
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateSearchPreferences: (SearchPreferenceList) => dispatch(UserActions.updateSearchPreferences(SearchPreferenceList)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPreferences);